// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { InfomationsModel } = initSchema(schema);

export {
  InfomationsModel
};